import React from 'react'
import { Box } from '@material-ui/core'
import Page from 'src/component/Page'
import Banner from './Banner'
import MintSection from './MintSection'
import Team from './Team'
import RoadMap from './RoadMap'
import How from './How'
function Home(props) {
  return (
    <Page title="RoonScapeZ">
      <Box>
        <Banner />
        <MintSection />
        <RoadMap />
        <Team />
        <How />
      </Box>
    </Page>
  )
}

export default Home
